import { isLocalDev } from '@/utils/checkRuntime';

export const CHANGE_PASSWORD_LOCK_TIME_HOURS = 24;
export const REQUEST_CODE_LOCK_TIME = isLocalDev ? 5 : 60;
export const DEFAULT_PAGE_SIZE = 10;
